import { loginRequest } from '@/authConfig'
import { API_ACCESS_TOKEN_SCOPE } from '@/config/constants'
import { msalInstance } from '@/main'
import { InteractionRequiredAuthError } from '@azure/msal-browser'

export default async function getAccessToken(
  forceRefresh = false,
): Promise<string | null> {
  const account = msalInstance.getActiveAccount()

  if (!account) return null

  try {
    const response = await msalInstance.acquireTokenSilent({
      scopes: [API_ACCESS_TOKEN_SCOPE],
      account,
      forceRefresh,
    })
    return response.accessToken
  } catch (error) {
    console.error('Error acquiring token silently:', error)

    // If user interaction is required, try to acquire token via popup
    if (error instanceof InteractionRequiredAuthError) {
      try {
        const response = await msalInstance.acquireTokenPopup(loginRequest)
        return response.accessToken
      } catch (popupError) {
        console.error('Error acquiring token via popup:', popupError)
      }
    }
    // Optionally, log out if unable to get token
    msalInstance.logoutRedirect()
    return null
  }
}
